module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapnum"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lucius Artorius Castus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A funerary inscription from Epetium, near Salona (Dalmatia), in modern Croatia, preserves the military career of a Roman equestrian. Lucius Artorius Castus was a Roman military commander who served in the second to third centuries. In fact, two inscriptions were discovered in the nineteenth century. We can see the location on the map below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first is a sarcophagus inscription broken into two pieces and found set in the wall of a churchyard. The second a memorial plaque, also broken, and found nearby. There is some dispute about the exact lettering and it has also suffered weathering damage. We can see the actual stone in picture two below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An important point to mention is that some of the letters are ligatured. This is when two or more letters are joined together, similar to ‘AE’ when written as ‘Æ’ in the Anglo-Saxon name Æthelberht. In order to represent this I have underlined the relevant letters so it is clearer for the reader to decipher. Lastly the figure ‘7’ is used for the symbol which indicates the post of centurion. The dots indicate where the text has been lost to damage.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 1")]), _vm._v(": Map of location of inscriptions.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0002-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 2")]), _vm._v(": Picture of funerary inscription stone of Lucius Artorius Castus. (Wikimedia commons)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It must also be remembered abbreviations were common in inscriptions, such as leg for legionis, or P P for primus pilus.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("L ARTORI…………………………………..STVS 7 L"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("E")]), _vm._v("G")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("III GAL"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("LI")]), _vm._v("CAE ITEM …………………..G VI FERRA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("TAE "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("IT")]), _vm._v("EM 7 LEG II ADI…………."), _c('span', {
    staticClass: "underline"
  }, [_vm._v("TE")]), _vm._v("M 7 LEG V M")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C I"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("TE")]), _vm._v("M P P EIVSDEM …………….. PRAEPOSITO")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("CLASSIS MISENATIVM ……………."), _c('span', {
    staticClass: "underline"
  }, [_vm._v("AE")]), _vm._v("FF LEG VI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("VIC"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("TR")]), _vm._v("ICIS DVCI LEGG ………….M BRITANICI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("MIARVM "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("AD")]), _vm._v("VERSVS ARM….S P"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("RO")]), _vm._v("C CE"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("NTE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("NARIO P"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("RO")]), _vm._v("VINCIAE LI…………….… GLADI VI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("VVS IPSE SIBI "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("ET")]), _vm._v(" SVIS …………………ST……….")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The second inscription is as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("L * ARTORIVS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("CASTVS * P * P")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("LEG * VMAC * PR")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("AEFEC..VS * LE..")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("VI * VICTRIC *")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Proposed translation (and expansion):")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lucius Artorius Castus")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Primus Pilus legionis V Macedonia")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Praefectus legionis VI Victrix")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A third, unconfirmed, find is an eighteenth-century discovery of a signet ring bearing the following: LVCI ARTORI CASTI (Lucius Artorius Castus)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn1",
      "id": "ch1fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" If the first two inscriptions are connected, as seems probable, then we can use the second to deduce the missing portion of the name from the first line of the sarcophagus inscription. Filling in the damaged section might reveal the following (missing letters and expanded abbreviations in brackets):"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn2",
      "id": "ch1fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("L(ucius) Artori[us Ca]stus centurioni leg(ionis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("III Gallicae item [centurioni le]g(ionis) VI Ferra-")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("-tae item centurioni leg(ionis) II Adi[ut(ricis) (P{iae} F{idelis})")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("i]tem centurioni leg(ionis) V M[a]-")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("-c(edonicae) item p(rimo) p(ilo) eiusdem [leg(ionis)] praeposito")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("classis Misenatium [pr]aef{f}(ecto) leg(ionis) VI")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Victricis duci legg(ionum) [triu]m Britan(n)ici-")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("–{an}arum adversus Arm[enio]s proc(uratori) cente-")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("-nario provinciae Li[burniae iure] gladi(i) vi-")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("-vus ipse sibi et suis [… ex te]st[amento]")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One possible translation of the sarcophagus is as follows:"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn3",
      "id": "ch1fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the divine shades, Lucius Artorius Castus, centurion of the Third Legion Gallica, also centurion of the Sixth Legion Ferrata, also centurion of the Second Legion Adiutrix, also centurion of the Fifth Legion Macedonica, also chief centurion of the same legion, in charge of (Praepositus) the Misenum fleet, prefect of the Sixth Legion Victrix, commander of three British legions against the Armenians, centenary procurator of Liburnia with the power of the sword. He himself (set this up) for himself and his family in his lifetime.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is possible it reads two (duarum) British legions rather than three. We can lay out his career as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Centurion of legion III Gallica")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Centurion of legion VI Ferrata")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Centurion of legion II Adiutrix (Pia Fidelis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Centurion of legion V Macedonia")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prima Pilus of legion V Macedonia")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Praeposito of the fleet of Misenum")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Praefectus of legion VI Victrix")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dux of the British legions against the Armenians")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Procurator of the Province of Liburnia")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Artorii were a family of Italian origin, possibly from the south of the peninsula."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn4",
      "id": "ch1fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" There is evidence they owned property in the area around Salona, Croatia, in the late second or third century."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn5",
      "id": "ch1fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" This would suggest either Lucius had family in that area, or their position derived from his appointment as procurator. There is no evidence of their presence from the first century. Nor do we get any reference to Lucius or his descendants from any other source. What we can be sure about is he finished his career in modern Croatia, probably at an advanced age, after a lifetime’s service to the empire.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Definitions and debates")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is worth briefly describing some of the definitions and terms used through the book. These will all be discussed in far more detail later and it is worth bearing in mind there were always exceptions, and ad hoc and temporary positions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Social order: the Roman empire had a fairly rigid hierarchical social structure. The bulk of the Roman people, soldiers, townspeople and tradesmen, were plebeians. The second rank were equestrian. These filled various military and administrative posts. The top rank were the senators. In the second century it was generally only senators who led legions and governed provinces, with some important caveats. There are many examples of equestrians and freedmen who rose through the ranks and various posts to enter the senate. This became more common throughout the second century. Artorius is identified as an equestrian, at least by the end of his career.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Governors and procurators: in general senators acted as provincial governors. There were two main types. Those provinces, such as Britain, where the governor reported direct to the emperor were called imperial "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("provinces. Those that reported to the senate were called senatorial provinces. Proconsuls, in senatorial provinces, held office for a year. In imperial provinces, proprietorial governors, legati Augusti pro praetore, held office for two to three years. In each province was an independent equestrian procurator who dealt with financial matters and reported direct to the emperor. This procurator had his own staff. There were also many more sub procurators, both equestrian and freedmen, Augusti liberti, who collected the many taxes and dues. Governors and procurators were thus separate posts and different ranks. However, there were some exceptions. Some minor provinces in the first century had equestrian prefects as governors. Later these were run by equestrian procurators, although Egypt remained what was known as a Praefectura. In the second century smaller provinces such as Noricum and Raetia had equestrian procurators as governors. For our investigation we thus need to remember the following important points: Artorius Castus reached the rank of equestrian; Liburnia might have been a temporary independent province governed by an equestrian procurator; however Britannia, in the period with which we are concerned, was always an imperial province governed by a senatorial legati Augusti pro praetore. Thus it follows that it is very unlikely Artorius was a governor of Britannia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Centurion")]), _vm._v(": A legion was made up of ten cohorts. Numbers two to ten each had six cohorts, which in turn consisted of six centuries of eighty men. Thus each cohort had six centuries commanded by a centurion. Artorius Castus held four such posts in succession and thus commanded eighty men. In the later posts, if he was the senior centurion in cohorts two to ten, he may have led the cohort of 480 men in the absence of a senior officer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Primus pilus")]), _vm._v(": The primus pilus, or first spear, was the senior centurion in the legion. The first cohort of each legion consisted of five double centuries of 160 men, each led by a centurion. Thus the primus pilus led the first century of the first cohort. In the absence of a senior officer he could lead the cohort of 800 men.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praepositus")]), _vm._v(": An equestrian officer in temporary command of units or logistics. This became an official title or post in the third century. If it is a second-century date, then this is more likely a description rather than a title. It has been described as a verb, ‘put in charge of’, rather than a noun, ‘commander’ or similar."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn6",
      "id": "ch1fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" If it was temporary, then we could perhaps speculate it was of short duration.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praefectus")]), _vm._v(": As the inscription specifies legion VI Victrix, this is unlikely to mean a praefectus of an auxiliary unit attached to that legion. It is generally interpreted as praefectus castrorum, camp prefect, who was third in command behind the legion commander and the legionary tribune. Towards the end of the second century, castrorum was dropped from inscriptions. However its absence has caused some to speculate he was actually an equestrian legionary commander, praefectus legionum. While this might indicate a mid-third century date, there is an event in the "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 180s that could explain this. The Artorius-Arthur theory places much weight on this interpretation and we will look at this in detail. Finally, a legion had four, thirty-man cavalry units, or turmae attached. This too was commanded by a praefectus. The Arthur-Artorius proponents list four possible ranks: praefectus legionis agens vice legati, praefectus castrorum, praefectus of the legion, and praefectus Sarmatarum gentilium."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn7",
      "id": "ch1fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" They propose he was a praefectus of the Sarmatians and commander of all three legions."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn8",
      "id": "ch1fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" These claims will also be looked at in great detail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The double ‘FF’ on the inscription suggests a plural, thus multiple units or camps or a shared command. All options were equestrian posts and this debate is one crucial to the investigation. However, it is also quite possible the second ‘F’ was a stone cutter’s mistake. The second inscription reads praefec(t)us. Perhaps the intention was PR"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("AE")]), _vm._v("FE LEG VI instead of what we have: …"), _c('span', {
    staticClass: "underline"
  }, [_vm._v("AE")]), _vm._v("FF LEG VI. Yet generally such inscriptions would not have a second E and simply read PRAEF."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn9",
      "id": "ch1fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" It is thus uncertain whether it is an error or indication of a plural.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Duci")]), _vm._v(": The dative form of dux, indicating the dedication on the slab is ‘to the dux’. Similar to praeposito, this could simply be a descriptor to denote leadership or temporary command of a force. From the Severan period ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 193–235) it evolved into a military title. This is another important part of the inscription. If it is simply describing what he did, then dating is difficult. If it is an official title for an equestrian, then it is more likely to date from after the late second century.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Legg…..m……Britanicimiarum")]), _vm._v(": The double ‘g’ denotes plural, thus legions. The missing letters before ‘m’ are best suited to the three, trium, rather than two, duarum. A cavalry unit, alarum, is also possibly too long. Britanicimiarum is regarded as a mistake for something like Britanniciniarum or Britannicianus."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn10",
      "id": "ch1fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Whatever the case, this reads as a force from, or of, Britain. This is another crucial debate. Usually this would "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("mean units from the three legions of Britain. However, the absence of vex for vexillations (parts of) is used to argue the inscription means the entire three legions. This in turn is used to support the case for ARM- meaning armed men (in Britain) and not Armenia. However, as we shall see, there are other explanations including the presence of units described in similar terms on the Rhine. This, and the following definition, are perhaps the most important points to discuss.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Adversus Arm-")]), _vm._v(": There are two parts to this debate. The first concerns whether there was a ligature after the M, as the first record of the stone indicates. This would suggest an E and thus probably ARMENIOS. However, the absence of a ligature would not negate that possibility and thus the three main suggestions are as follows: ARMORICANOS, a region of north west Gaul; ARMATOS, meaning armed men; and ARMENIOS, suggesting a campaign in Armenia. We will look at this in more detail below.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Centenario provinciae Liburniae iure gladii")]), _vm._v(": A procurator was an equestrian position, usually involving financial administration such as collection of taxes. There were procurator governors for minor provinces or for temporary ad hoc positions. Liburnia was a sub-region of Dalmatia, but it may have been independent for a period in the late second to early third century. Procurators were graded 60,000, 100,000, 200,000 or 300,000 sesterces. Artorius was a procurator centenarii. The term ius gladii, means roughly ‘the power of the sword’. This gave him power to try capital cases which was normally reserved to governors. For the sake of completeness we should mention the unlikely scenario that LI- does not represent Liburnia. There is one other potential region, Liguria in north-west Italy, which was a province in the fourth century. Although this would require an unattested ad hoc province in the second or third century and the coincidence of Castus retiring to the only other province beginning with LI-. This makes little difference to our investigation so we will continue on the basis it is indeed Liburnia on the Dalmatian coast.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Armenia, Armatos or Armorica")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From one of the early readings some have suggested the missing letters should be -ORICANO giving us ARMORICANOS. This would indicate a campaign in modern-day Brittany. Much of this was an attempt to fit a campaign to the theory of a connection with the Arthurian legend. As we "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("shall see, Geoffrey of Monmouth in the twelfth century has Arthur leading his army to Gaul and features many links with the Bretons. Against this is the available space on the stone and the fact the regional names Armoricani or Armorici are not found in other inscriptions, whereas derivatives of Armenia are. Nor do we have any record of unrest in Armorica in the time period suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The general dismissal of the above explanation has caused some Artorius-Arthur theorists to search for an alternative explanation. They have fallen on -ATO which does indeed fit the gap. This would give ARMATOS, meaning armed men. This then can be used to mean any group in any location. It cannot be used to definitively mean fighting with Britons in Britain. A unit name did not necessarily indicate the ethnic make up. Unfortunately, this interpretation is not supported by examples of similar inscriptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are references to armatos in literary sources. This should come as no surprise as it is a common Latin word, but it does not appear in inscriptions referring to campaigns. It occurs on a small number of longer inscriptions, but not on funerary monuments similar to Artorius Castus. A number of examples demonstrate this:"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn11",
      "id": "ch1fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" first, the usual phrase used is adversus rebelles hostes publicos. A similar inscription describes Candidus in Spain c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 194 fighting, ‘against public enemies of the Roman people’. Another monument from Spain at the end of the second century records victories of Septimius Severus in the civil wars against Niger. It simply refers to Claudius Candidus as: duci exercitus Illyrica expeditione Asiana item Parthica item Gallica. This translates as: ‘Leader of the Illyrican army on the Asian, Parthian and Gallic expeditions.’ There is no indication these campaigns were against fellow Romans, thus armatos is unattested in this context. This makes it unlikely rather than impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would appear that the earliest reading gives us a clue. The Croatian archaeologist Francesco Carrara in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 1850 recorded the now weathered stone as adVERSUS ARME- with a ligatured ME. The E has since disappeared and it would seem most subsequent editors followed the writings of Theodor Mommsen in the early twentieth century, who either missed, or could not see, the E. Many academics are therefore confident the correct reading is adVERSUS ARMENIOS, against the Armenians. However, this has not prevented proponents of the King Arthur theory to maintain a different opinion. The claim is Carrara was mistaken and there is no E visible now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are three campaigns in our time period that involved a Roman military campaign in Armenia: under Lucius Verus, "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 161–6; Caracalla, "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 215–7; and Severus Alexander in c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 233. All three were part of a wider Parthian War. What is certain, however, is the Armenian campaigns were distinct parts of those wars and involved Romans fighting Armenians in Armenia. One less likely event was the Parthian campaign of Septimius Severus of "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 197. Severus had intended to attack Armenia but their king sent money, hostages and gifts and there is no record of a Roman invasion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Armorica and Armatos we have opposite problems. For the first, we have no record of any unrest in the area for that period. The second option is open ended and thus difficult to pin down. Usually barbarian opponents were named, while civil wars or mutineers were labelled enemies of the people or similar. We have a number of possible events that could conceivably involve leading detachment or legions from, or in, Britain against ‘armed men’. First, there was a revolt of the northern tribes in Britain in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 155–8 under the emperor Antoninus Pius. Second, there was a major war in Britain in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 182–5. Importantly, we will hear of the Praetorian Prefect Perennis appointing equestrian legion commanders in Britain before his execution in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 185. This, then, is the window of opportunity for a praefectus legionis in the second century. The Artorius-Arthur theory takes this many steps further as we will see. They state that not only did Artorius hold an official title of dux, but he was also an equestrian governor of Britain after "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 185. The next period of unrest follows on from the first, between "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 185–7 when Pertinax was temporarily posted as governor but resigned after being attacked by the soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is one occasion when someone did lead the legions away from Britain. In the civil war with Septimius Severus, Clodius Albinus had taken his army to Gaul in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 196 only to be defeated at Lugdunum the following year. It is possible, with Artorius on the losing side, he would be discreet in commemorating his actions and not wish to name his enemies as the army fighting for the sitting emperor, or his successor. Alternatively, we hear of the emperor ‘settling things in Britain’. It is possible this involved a mopping-up operation of supporters of Clodius.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final options occur at the end of the reign of Septimius Severus. Around "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 208 we hear of an appeal by the governor due to a barbarian revolt overrunning the country. The legions no doubt would have responded against these ‘armed men’, but more was to follow. The emperor personally led an invasion of Scotland in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 209–11 that would have involved Artorius’s legion based at York. In fact, such a massive campaign required multiple forts and camp commanders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We thus have a significant number of options for both Armenia and Armatos and we will discuss each historical event in more detail in the "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")]), _vm._v(". Regarding the link to Arthurian legends much of this makes little material difference. One would expect a centurion to fight ‘armed men’ at some point. Nor should it come as a surprise if someone stationed in Britain fought with units from Britain, whether they contained ethnic Britons or not. What we require is something linking these events with the fifth century or later. An example might be a battle in the second century at a location similarly named as one in the battle list. Of course, even that would not be enough as battles often occurred in the same strategically important place multiple times over several centuries. However, a Roman battle at Mons Badonicus in the second or third century would certainly cause one to sit up. Unfortunately, not only do we have no such link, we have have no evidence Artorius fought a single battle anywhere. Certainly a mature camp commander might have spent his entire time safe at York. Even a commander leading units, or legions, might not do any fighting and might exaggerate his command on his memorial stone, whether it was in Armenia or elsewhere.")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A military career")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let us look at the units a little more closely. There were generally two common routes to the rank of centurion. The first, and most common, was from experience and talent, which meant most took fifteen to twenty years to achieve the rank. The second route was through political connections for those of equestrian class with the minimum age of, usually, 30. Thus Artorius would have been about 30 years of age when he became a centurion. Possibly younger if he was already an equestrian, but older if he started as a plebeian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Map 2 shows the location of these posts. For his post as Dux I have displayed the four main options of Armenia, Britain, Armorica and the battle of Lugdunum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His first two postings were in the East in Syria and Judea. He then moved to the Danube region where he eventually became the Primus Pilus. At this rank he would be eligible on retirement for equestrian rank. However, he may have had ambitions to rise further, or perhaps he was young and well connected enough to continue his career. A praepositus was often a temporary post or a command of part of the fleet and this would be a logical move for a primus pilus. By the time he was posted to Britain he was very likely of mature years in a time when life expectancy was relatively short. His next post was a praefectus legionis, and it is worth noting at this point the command structure of a legion.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Table 1: The military career of Lucius Artorius Castus")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1h"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Post and rank")])]), _vm._v(" "), _c('td', {
    staticClass: "td2h"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Details")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Centurion legion III Gallica")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("For most of the second and third centuries this was stationed in Syria.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Centurion legion VI Ferrata")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("From middle of second century to early third, this was stationed in Judea.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Centurion legion II Adiutrix")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("From early second century based at Aquincum (Budapest). Took part in campaigns against the Marcomanni and Quadi (north of the Danube) in the second century. Also the Parthians, and in the third century the Sassanids.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Centurion and Primus Pilus of legion V Macedonia")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Based in Dacia in second and most of the third century.")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("Took part in campaigns against the Marcomanni, Sarmatians and Quadi (north of the Danube) in the second century. The rank of Primus Pilus was generally given to career soldiers of 45–50 years of age.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Praepositus of the Misenum fleet")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Based at Misenum in Italy but with units posted at various locations.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Praefectus of legion VI Victrix")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Based at York in Britain from the early second century. A Praefectus Legionis was third in command and usually an experienced soldier of 50–60 years old.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Dux of the British legions")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Dux was a temporary command of either a collection of troops or entire units or legions.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Procurator of Liburnia")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Talented equestrian prefects sometimes obtained high civilian rank on retirement.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The commander of a legion in the period we are looking at was a legatus legionis, who was of senatorial rank; he would also be governor if there was only one legion in the province. In imperial provinces he was appointed by the emperor himself; in senatorial provinces, in theory at least, he was appointed by the senate. Later in the third century as senators fell out of favour, an equestrian commander, praefectus legionis, led the legion. Second-in-command was a senatorial tribunus, usually young and "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("inexperienced but assisted by five equestrian tribunes, often battle-hardened veterans. Third in command was the camp prefect, praefectus castrorum. This was often a man of considerable experience who had risen through the ranks. The primus pilus was the senior of the fifty-nine centurions in the legion. Divided into ten cohorts it consisted of 5,120 men. Each legion had a small cavalry wing also commanded by a praefectus. The auxiliary units were not part of the legion although they were sometimes attached to a legion for some time. For the sake of completeness I have included them in the command structure of "), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter01#fig4"
    }
  }, [_vm._v("figure four")]), _vm._v(". I have also highlighted the various posts that might be relevant in this investigation.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 3")]), _vm._v(": Map showing the career of Lucius Artorius Castus.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Figure 4")]), _vm._v(": Legion command structure.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In summary there appears to be four choices for praefectus. An auxiliary unit is unlikely as the inscription seems clear; a prefect of a legionary cavalry unit is also unlikely for similar reasons. The consensus among historians is for praefectus castrorum as the absence of castr on the inscription is fairly normal for this period. The Artorius-Arthur theory claims it is a praefectus commander of a legion. This would normally date to after the mid-third century, but we do indeed have evidence for equestrian replacing senators as commanders prior to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 185. However, the theory also claims Artorius was acting governor for several years. The Artorius-Arthur proponents suggest a fifth option, that Artorius was praefectus Sarmatarum gentilium (‘praefect of the Sarmatian people’). Extraordinary claims require extraordinary evidence and so we will need to look at this in far greater detail in later chapters. The table below lays out the various options for the most debatable terms:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Central to the alleged connection with the Arthurian legend is the placing of Artorius in Britain in the late second century. Another important factor of this theory is the alleged link with Sarmatians between both Artorius and aspects of the later legend. Specifically after "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 175 when Sarmatian units were posted to Britain by Marcus Aurelius after their devastating defeat in the first Marcomannic War. Thus the argument is he must have commanded troops in Britain at the same time Sarmatians were present, and must have fought battles in Britain. If it could be shown he also commanded whole legions and was governor, the hope is this adds weight to the evidence. The counter argument is twofold: first, there is no evidence to support these theories and much evidence to the contrary; second, it is all rather irrelevant as what is required is something linking Artorius with the Arthurian legends or vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Table 2: Debatable terms and options")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Time frame")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For this topic we must turn to the experts. One such expert on Roman inscriptions in Britain is R. Tomlin. It is worth quoting his comments in his 2018 book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Britannia Romana, Roman Inscriptions and Roman Britain")]), _vm._v(":"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn12",
      "id": "ch1fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" ‘The inscription is undated, but the quality of lettering and the well-executed band of lush ornament to left and right, twinning scrolls inhabited by rosettes, would suggest it was Antonine (c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 140–90).’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following that assessment, Nicholas Higham provided a likely timeline based on the most up-to-date research."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn13",
      "id": "ch1fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" The estimated time of his posting as praefectus of legion VI Victrix based at York is c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 160. This would place his appointment as Dux in the mid "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 160s and indeed we do find a very likely historical campaign in the East involving Armenia. The most likely timeframe for his appointment as Procurator is in the "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 170s, and thus he would no longer be in Britain in the last quarter of the century. Working backwards we can estimate his floruit as beginning c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 110. He would have reached the age required to be a centurion c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 140, serving first in Syria and Judea before moving to the Danube. This would place him as centurion, then Primus Pilus, of legion V Macedonia in the Danube region c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 150. The inscription is claimed by some to be no later than "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 200, so we could narrow down the emperors under which Artorius served to the second century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, there may be something significant about the last line of the inscription: ‘centenary procurator of Liburnia with the power of the sword. He himself (set this up) for himself and his family in his lifetime.’ First, it would appear Castus himself commissioned the work during his lifetime; second, the phrase ‘with the power of the sword’ needs some explanation."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn14",
      "id": "ch1fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Equestrian Procurators often had responsibility for financial matters in a province and may have had judicial authority in those areas. They did not have the power to sentence Roman citizens to death. The term ius gladii referred to this right being granted by the emperor. One such example is "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("P. Aelius Hilarianus in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 202, ‘the Procurator, who at that time had received the right of the sword in the place of the proconsul.’ From the end of the second century it became more common for procurators to act as praeses of a province. Caillan Davenport in the extensive "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of the Roman Equestrian Order")]), _vm._v(", gives two examples in the Severan period of similar language on inscribed stones. The first is a C. Titius Similis, Procurator of Moesia Inferior. The second is L. Artoius Castus who Davenport suggests was acting governor of Dalmatia, replacing a senatorial legate. She thus places Castus in the early third century."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn15",
      "id": "ch1fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Xavier Loriot, writing in 1997, made a number of relevant points."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn16",
      "id": "ch1fn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" First, he confirmed the interpretation of Mommsen in 1919 regarding Armoricans is a ‘hazardous’ reading. He agreed the appropriate reading is adversus Arme[nio]s. Second, the dating is later than believed, after the reign of Commodus. It is worth quoting the exact wording used in the study: ‘The epigraphic parallels show unequivocally that the form used belongs to the third century. Functions such as praepositus classis or procurator iure gladii do not occur before the Severan period and the first dated mention of a dux legg (ionum) is under Philip the Arab ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 244–249).’ This is not to say the word dux or duci was not used in inscriptions earlier. Rather this refers to the exact wording used. The Armenian campaign of Caracalla in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 216–7 is suggested. A later time, such as during the reign of Severus Alexander "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 222–235, can not be excluded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anthony Birley, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Roman Government of Britain")]), _vm._v(", agrees with Loriot above, concerning the dating and the original reading of the inscription as referring to Armenia."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn17",
      "id": "ch1fn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" He thus also suggests the most likely campaigns were that of Emperor Caracalla in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 216–7 or Severus Alexander in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 230–232. In contrast to this, Wilkes argues the appointment of an equestrian as opposed to a senator as a legionary commander was unusual."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Endnotes#rch1fn18",
      "id": "ch1fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" He describes the last post as a special governor, procurator iure gladii. This post in Liburnia could have been seen as an infringement of the consular senator governing Dalmatia. Wilkes argues that this is so unusual it could be attributed to the praetorian prefect Perennis under Commodus. The preference for equestrians over senators for appointments may have contributed to his downfall in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 185.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is clearly still much debate around the date. Higham and Tomlin place him as early as the mid-second century. Birley, Loriot and Davenport place him in the early third. The Artorius-Arthur theorists propose a date in the middle. We could summarise this as follows: the form and style of the inscription favour an earlier date, while the wording and terms suggest a later date in the early third century. For our purposes we shall retain as "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("wide a window as possible, 150–250 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(", and hope to narrow this as we go forward. The Artorius-Arthur theorists insist on the very specific timeframe below:")]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1.")]), _vm._v(" Prefect of the legion (commander) VI Victrix "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 180–187.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2.")]), _vm._v(" Dux of the British legions and acting governor of Britain "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 187–191.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3.")]), _vm._v(" Governor of Liburnia and Ius Gladii (for six years) "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 191–197.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The claim is that the career of Artorius is unique and exceptional, especially with reference to his procuratorship. Similar claims are made about the ‘post’ of Dux. In later chapters we will compare the career of Artorius to other examples to determine just how exceptional his career was. We will also take a close examination of the sources with particular attention for events related to our various options concerning Armenia, Armorica or ‘armed men’. Two of our sources, Cassius Dio (c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 155–235) and Herodian (c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 170–240) are contemporary. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia Augusta")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aurelius Victor")]), _vm._v(" are both approximately a hundred years later. The table below gives a list of the relevant emperors and some of the possible events related to our options, to allow the reader to consider the various possible timeframes.")]), _vm._v(" "), _c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Table 3: Roman Emperors and relevant campaigns")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1h"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Emperor")])]), _vm._v(" "), _c('td', {
    staticClass: "td2h"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Major Roman-Parthian wars affecting Armenia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Trajan "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 98–117")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("114 Invasion and annexation of Armenia by Rome")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Hadrian "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 117–138")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Hadrian withdraws from Armenia and other eastern areas.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Antomius Pius "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 138–161")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("155–8 revolt in Britain.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Marcus Aurelius "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 161–180 (Lucius")]), _vm._v(" "), _c('p', {
    staticClass: "tab"
  }, [_vm._v("Verus co-emperor "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 161–169)")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("161–166 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" Roman-Parthian war")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("163 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" capture of Armenian capital")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("166–175 1st Marcommanic War on Danube/Rhine border")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("175 revolt of Avidius Cassius in Egypt")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("177–80 2nd Marcomannic War")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Commodus "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 180–192")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("180–2 3rd Marcomannic War")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("180–4 war in Britain, Perennis promotes equestrians")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("185 Army mutiny")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("186–7 Army mutiny")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Pertinax "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 193")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Julianus "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 193")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Septimius Severus "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 193–211")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("194 Civil war in East against Niger")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("195 War against Parthia")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("196 Albinus takes troops from Britain to Gaul")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("197 Severus defeats Albinus")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("197 Parthian campaign")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("208 unrest in Britain")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("209–11 Invasion of Scotland")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Caracalla "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 211–217 (Geta co-emperor "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 211–212)")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("211 Caracalla leaves Britain. Geta murdered.")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("c. 212 Britain divided into two provinces")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("216–217 campaign against Armenia and Parthia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Macrinus "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 217–218")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("217 Battle of Nisbis, Romans pay tribute to Parthians, but retain client king in Armenia")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Diadumenian 218")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Elagabalus "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 218–222")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Severus Alexander "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 222–235")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("226 Parthians defeated by the Sassanids")]), _vm._v(" "), _c('p', {
    staticClass: "tabt"
  }, [_vm._v("230–232 Roman-Sassanid conflict in Armenia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Maximinus Thrax "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 235–238")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")]), _vm._v(" we will look at the career of Artorius, the posts he held and the claims above in greater detail. Next, however, we will turn to the much later legend of King Arthur to ascertain if there is any hint of a link to Artorius, Sarmatians or the Roman Empire.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057d52d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter01.vue
// module id = 81
// module chunks = 0